
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { setCreateSubstepOpen, setRecipeData, setSubstepToEdit } from "../../../app/recipeCreation/createRecipe.slice";
import { outsideInstructionInterface, recipeSubStepInterface2, Substep } from "../../../app/recipeCreation/createRecipe.types";
import { setRecipe } from "../../../app/recipePage/recipePage.slice";
import { useAppDispatch, useAppSelector } from "../../../app/store/hooks";
import { BlueDot, DeleteStepIcon } from "../../../utils/iconRefs/recipeStepsIcons";
import { logEvents } from "../../../utils/logging";
import { recipeE3TransformerQL2FS } from "../../../utils/RecipeBackEnd/hasuraFSMigrationTransformers";
import LocationUI from "./locationUI";
import styles from "./outsideInstruction.module.css";
import QuillEditor from "./QuillEditor";

const OutsideInstruction = ({ stepId, stepIndex, substep, userCreated, userCreatedRecipe, substepIndex }: { stepId: string | null, stepIndex: number, substep: outsideInstructionInterface, userCreated: boolean, userCreatedRecipe: boolean, substepIndex: number }) => {
    const editStepView = useAppSelector((state) => state.recipeCreation.editStepView)
    const recipeData = useAppSelector((state) => state.recipeCreation.recipeData)
    const { name, parameters, type, id, subStepUId } = substep;
    const { location, outsideDescription } = parameters
    const dispatch = useAppDispatch();
    const user = useAppSelector((state) => state.main.user);
    const device = useAppSelector((state) => state.main.device);
    const step_id = recipeData.Recipe_Variations[0].RecipeVariations_Steps[0].StepsE3.id;
    const { imageURL, videoURL, ...excludedSubstepMedia } = substep.media
    const substepDataV2: Substep = { ...substep, media: { ...excludedSubstepMedia, url: substep.media.imageURL || substep.media.videoURL }, Recipe_Presets: substep?.Recipe_Presets ?? [], SubSteps_Ingredients_E3s: substep?.SubSteps_Ingredients_E3s ?? [] };

    const onEdit = () => {
        dispatch(setSubstepToEdit({ SubstepsE3: substep, subStep_id: substep.id, subStepUId, subStep_rank: 0, step_id }))
        dispatch(setCreateSubstepOpen(true))
        logEvents('null', "APP_RECIPE_SUBSTEP_EDIT", {
            recipeId: recipeData?.id ?? null,
            userId: user?.id ?? null,
            deviceId: device?.displayName ?? device?._id ?? null,
        })
    }
    const onDelete = () => {
        if (editStepView) {
            const recipeDataEditable = JSON.parse(JSON.stringify(recipeData))
            const foundSubStep = recipeData.Recipe_Variations[0].RecipeVariations_Steps[0].StepsE3.Steps_Substeps.find((Steps_Substeps: recipeSubStepInterface2) => Steps_Substeps.SubstepsE3 === substep);
            const subStepIndex = recipeData.Recipe_Variations[0].RecipeVariations_Steps[0].StepsE3.Steps_Substeps.indexOf(foundSubStep)
            if (subStepIndex > -1) {
                recipeDataEditable.Recipe_Variations[0].RecipeVariations_Steps[0].StepsE3.Steps_Substeps.splice(subStepIndex, 1);
                dispatch(setRecipeData(recipeDataEditable))
                dispatch(setRecipe({ recipe: recipeE3TransformerQL2FS(recipeDataEditable) }))
            }
        }
    }

    const outsideInstructionConfig: any = {
        PADDING: editStepView ? '10px 10px 10px 4px' : '10px 10px 10px 8px',
        SUBSTEP_ICON: editStepView ? <DeleteStepIcon /> : <BlueDot />,
        LOCATION_UI: userCreatedRecipe ? <LocationUI
            location={location}
            name={name}
            onEdit={onEdit}
            stepId={stepId}
            stepIndex={stepIndex}
            substep={substepDataV2}
            substepId={id}
            substepIndex={substepIndex}
            subStepUId={subStepUId}
            type={type}
            userCreatedRecipe={userCreatedRecipe} /> : <LocationUI
            location={location}
            name={name}
            stepId={stepId}
            stepIndex={stepIndex}
            substep={substepDataV2}
            substepId={id}
            substepIndex={substepIndex}
            subStepUId={subStepUId}
            type={type}
            userCreatedRecipe={userCreatedRecipe} />,
        EDITOR: userCreated ? <QuillEditor readOnly theme="bubble" value={outsideDescription} /> : <Typography className={styles.outside_instruction_typography} variant='caption3Light'>{outsideDescription}</Typography>
    }

    return (
        <Box className={styles.main_container}>
            <Box className={styles.substep_dot}>
                <Box onClick={onDelete} sx={{ padding: outsideInstructionConfig.PADDING }}>
                    {outsideInstructionConfig.SUBSTEP_ICON}
                </Box>
            </Box>
            <Box className={styles.outside_instruction_header}>
                {outsideInstructionConfig.LOCATION_UI}
                <Box className={styles.outside_instruction_editor}>
                    {outsideInstructionConfig.EDITOR}
                </Box>
            </Box>
        </Box>
    )
}

export default OutsideInstruction